import React, { useState } from "react";
import Shape2 from "../../../assets/brand/choose-shape-2.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlay, faPhone } from "@fortawesome/free-solid-svg-icons";
import ModalVideo from "react-modal-video";
import "react-modal-video/scss/modal-video.scss";
import "../../../Styles/Redirecting Styles/FooterStyle/Hosting.css";
import CanadaHeader1 from "../../Components/seperate Components/CanadaHeader1";
import CanadaFooter from "../../Components/Footer";
import { Helmet } from "react-helmet";
import section1 from "../../../assets/canada/hosting/hosting-sec-1-1.jpg";
import section2 from "../../../assets/canada/hosting/hosting-sec-1-2.jpg";
import section3 from "../../../assets/canada/hosting/hosting-sec-1-3.jpg";

const CanadaHostingServices = () => {
  const [isOpen, setOpen] = useState(false);

  return (
    <div>
      <Helmet>
        <title>
        Website Hosting Services in USA | Zithas Technologies
        </title>
        <meta
          name="description"
          content="Discover Reliable Hosting Services in USA with Zithas Technologies. Fast, Secure, and Scalable Solutions for Your Website Needs."
        />
        <meta
          name="keywords"
          content="hosting services, hosting services USA, website hosting USA"
        />
      </Helmet>
      <CanadaHeader1 />

      <div
        className="bd-page-title-area bd-page-title-bg2 pt-220 pb-155"
        style={{ height: "380px" }}
      >
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div
                className="bd-page-title text-center z-index"
                style={{ bottom: "45px" }}
              >
                <h2 className="breadcrumb-title" style={{ fontSize: "50px" }}>
                  Explore Hosting Services
                </h2>
                <div className="breadcrumb-menu">
                  <nav className="breadcrumb-trail breadcrumbs">
                    <p style={{ color: "black" }}>
                      We offer a comprehensive array of features aimed at
                      empowering users to effectively manage websites.{" "}
                    </p>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* First section */}
      <section className="bd-choose-area fix pt-80 pb-80">
        <div className="container" style={{ maxWidth: "1270px" }}>
          <div className="bd-choose-shape">
            <div className="row respon_host">
              <div className="col-xl-6 col-lg-6 order-2 order-lg-1 pr-20">
                <div className="bd-choose-img text-end top-resp z-index">
                  <div className="row align-items-center custom-mar-15">
                    <div className="col-xl-6 col-lg-6 col-6 custom-pad-15">
                      <div className="bd-choose-img-inner mb-15 bd-choose-img-inner-1">
                        <img
                          src={section1}
                          className="resp-img bordertop-img1"
                          alt="img not found"
                        />
                      </div>
                    </div>
                    <div className="col-xl-6 col-lg-6 col-6 custom-pad-15">
                      <div className="bd-choose-img-inner mb-15">
                        <img
                          src={section2}
                          className="resp-img bordertop-img2"
                          alt="img not found"
                        />
                      </div>
                      <div className="bd-choose-img-inner mb-15">
                        <img
                          src={section3}
                          className="resp-img bordertop-img3"
                          alt="img not found"
                        />
                      </div>
                    </div>
                  </div>
                  <img
                    className="bd-choose-shape bd-choose-shape-2"
                    src={Shape2}
                    alt="shape img not found"
                  />
                  {/* <div className="bd-choose-video-popup">
                                    <a href="https://www.youtube.com/watch?v=jdkWIdJobSA" className="play_btn popup-video"><i className="fas fa-play"></i></a>
                  </div> */}
                </div>
              </div>
              <div className="col-xl-6 col-lg-6 order-1 order-lg-2">
                <div className="bd-choose-text  z-index">
                  <h2
                    className="bd-section-title mb-15"
                    style={{ fontSize: "46px" }}
                  >
                    Custom{" "}
                    <span
                      hosting
                      services
                      for
                      your
                      businessspan
                      style={{ color: "#ffbf1e" }}
                    >
                      {" "}
                      Hosting Services{" "}
                    </span>{" "}
                    Designed for Your Business
                  </h2>
                  <div className="bd-section-title-wrapper"></div>
                  <p
                    className="mb-20"
                    style={{ width: "95%", fontSize: "18px" }}
                  >
                    A hosting service offers a diverse set of tools to assist
                    users in website management, encompassing site optimization,
                    security measures, and backup functionalities. Utilizing a
                    hosting service can streamline your website tasks, such as
                    centralizing customer support, allowing you to save time
                    while keeping service options flexible.
                  </p>
                  <p className="mb-20" style={{ fontSize: "18px" }}>
                    Amplify your website's visibility and broaden its reach
                    through a trusted web hosting service. Elevate your online
                    presence, drawing the attention of digital marketers, and
                    cultivate a highly professional image for your Canadian
                    enterprise. At Zithas, we deliver exceptional hosting
                    services that encompass the following features.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <ModalVideo
          autoplay
          isOpen={isOpen}
          channel="youtube"
          videoId="L61p2uyiMSo"
          onClose={() => setOpen(false)}
        ></ModalVideo>
        <button
          style={{ display: "none" }}
          className="btn btn touch_pop_vid first_pop_hosting"
          onClick={() => setOpen(true)}
        >
          <FontAwesomeIcon
            icon={faPlay}
            className="play_bt_vid play_transition"
          />
        </button>
      </section>

      <section className="bd-service-area pb-80 ">
        <div className="container">
          <div className="row">
            <div className="col-lg-4 col-md-6 pt-20">
              <div className="bd-section-title-wrapper mb-50">
                <h2 className="bd-section-title" style={{ fontSize: "46px" }}>
                  Embrace the Strength of Custom{" "}
                  <span style={{ color: "#ffbf1e" }}>Hosting Services</span>{" "}
                </h2>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div
                className="bd-service mb-30"
                style={{ backgroundColor: "var(--clr-bg-gray)" }}
              >
                <div className="bd-service-icon mb-20">
                  <i>
                    <img src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659440581/website/icons/download-from-cloud-64_fewqme.png" />
                  </i>
                </div>
                <h4 className="bd-service-title mb-20">
                  <a>Cloud Hosting</a>
                </h4>
                <p>
                  Your website or application is securely hosted on a network of
                  virtual servers, ensuring unmatched reliability and resource
                  flexibility.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div
                className="bd-service mb-30"
                style={{ backgroundColor: "var(--clr-bg-gray)" }}
              >
                <div className="bd-service-icon mb-20">
                  <i>
                    <img src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659440581/website/icons/server-shutdown-64_eacgw5.png" />
                  </i>
                </div>
                <h4 className="bd-service-title mb-20">
                  <a>Dedicated Server</a>
                </h4>
                <p>
                  With our service, you gain comprehensive administrative
                  access, empowering you to customize servers and install
                  various software applications as needed.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div
                className="bd-service mb-30"
                style={{ backgroundColor: "var(--clr-bg-gray)" }}
              >
                <div className="bd-service-icon mb-20">
                  <i>
                    <img src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659440581/website/icons/vps-64_cr3pca.png" />
                  </i>
                </div>
                <h4 className="bd-service-title mb-20">
                  <a>VPS Hosting</a>
                </h4>
                <p>
                  With VPS hosting, you get your private virtual server,
                  allowing you to configure it to your specific requirements.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div
                className="bd-service mb-30"
                style={{ backgroundColor: "var(--clr-bg-gray)" }}
              >
                <div className="bd-service-icon mb-20">
                  <i>
                    <img src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659440581/website/icons/web-hosting-64_gd9bxw.png" />
                  </i>
                </div>
                <h4 className="bd-service-title mb-20">
                  <a>Web Hosting</a>
                </h4>
                <p>
                  Our top-notch server optimization delivers lightning-fast
                  performance and rapid loading times for all websites.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div
                className="bd-service mb-30"
                style={{ backgroundColor: "var(--clr-bg-gray)" }}
              >
                <div className="bd-service-icon mb-20">
                  <i>
                    <img src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659440581/website/icons/mail-64_hrvu3p.png" />
                  </i>
                </div>
                <h4 className="bd-service-title mb-20">
                  <a>Email Hosting</a>
                </h4>
                <p>
                  Our email server service operates differently from the typical
                  free webmail platforms such as Yahoo and Google, providing
                  distinct features and functionalities.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div
                className="bd-service mb-30"
                style={{ backgroundColor: "var(--clr-bg-gray)" }}
              >
                <div className="bd-service-icon mb-20">
                  <i>
                    <img src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659440581/website/icons/security-ssl-64_zklinw.png" />
                  </i>
                </div>
                <h4 className="bd-service-title mb-20">
                  <a>SSL Certificates</a>
                </h4>
                <p>
                  Securing an SSL Certificate enhances your website's safety,
                  increases client confidence, and elevates its SEO ranking.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div
                className="bd-service mb-30"
                style={{ backgroundColor: "var(--clr-bg-gray)" }}
              >
                <div className="bd-service-icon mb-20">
                  <i>
                    <img src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659440582/website/icons/web-shield-64_wmivpn.png" />
                  </i>
                </div>
                <h4 className="bd-service-title mb-20">
                  <a>Site Security & BackUp</a>
                </h4>
                <p>
                  Your online assets are in trusted hands with our comprehensive
                  security and backup solutions.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div
                className="bd-service mb-30"
                style={{ backgroundColor: "var(--clr-bg-gray)" }}
              >
                <div className="bd-service-icon mb-20">
                  <i>
                    <img src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659440582/website/icons/wordpress-64_hhc6v7.png" />
                  </i>
                </div>
                <h4 className="bd-service-title mb-20">
                  <a>WordPress Hosting</a>
                </h4>
                <p>
                  Elevate your online presence with our tailored WordPress
                  hosting solution ensuring your WordPress site runs smoothly,
                  securely, and efficiently.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section
        className="bd-video-area pt-135 pb-130"
        style={{ backgroundColor: "#5c0385" }}
      >
        <div className="container" style={{ maxWidth: "1270px" }}>
          <div className="row responsive-banner">
            <div className="col-lg-12 first_section">
              <div className="bd-video-text">
                <h2 className="bd-video-title first-para-resp">
                  Looking for a Hosting Service Specialist in USA?
                </h2>
                <p className="contact_section second-para-resp">
                  You're here at the right moment.
                </p>
                <p className="contact_subtext">
                  Outstanding Hosting Service, Let's kick start now!
                </p>
              </div>
            </div>
            <div className="col-lg-12 second_section">
              <div className="contact-stuff pt-30">
                <div className="contact_icon icon_respon pt-15 pl-50">
                  <FontAwesomeIcon
                    icon={faPhone}
                    style={{ fontSize: "30px" }}
                  />
                </div>
                <div className="contact_txt ">
                  <p className="contact-sub-text">CALL US NOW</p>
                  <a
                    href="tel:+1 (307) 677-8060"
                    style={{ fontSize: "17px" }}
                    className="mbb-5 pb-20"
                  >
                    +1 (307) 677-8060
                  </a>
                </div>
              </div>
              {/* <Link to={"/contact-us"} onClick={toggleContact}>
                    <button className="touch-btn1 mt-20">Get Started</button>
                    </Link> */}
            </div>
          </div>
        </div>
      </section>

      <CanadaFooter />
    </div>
  );
};

export default CanadaHostingServices;
